import { createContext, useContext, type ReactNode } from "react";
import type { NlpResult, ParsedMessage } from "@/types";

export interface ChatUser {
  id: string;
  displayName: string;
  mail?: string;
  jobTitle?: string;
  department?: string;
}

interface ChatContextValue {
  messages: ParsedMessage[];
  users: ChatUser[];
  loading: boolean;
  pendingResult: NlpResult | null;
  peopleSearch: string;
  onPeopleSearchChange: (value: string) => void;
  onPickPerson: (ambigIndex: number, person: { id: string; displayName: string }) => void;
  onPickCategory: (catId: string) => void;
  onPickSubcategory: (subId: string) => void;
  onPickDuration: (mins: number) => void;
  onAddPerson: (user: ChatUser) => void;
  onSkipAddPeople: () => void;
  onConfirmSchedule: () => void;
  onEditSchedule: () => void;
}

const ChatContext = createContext<ChatContextValue | null>(null);

export function ChatProvider({
  value,
  children,
}: {
  value: ChatContextValue;
  children: ReactNode;
}) {
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used within ChatProvider");
  return ctx;
}
